<template>
  <div class="teas-buffer-page">
    <div class="image-wrap">
      <img :src="require('_teas/public/img/product/save.png')" alt="" />
    </div>
    <p>{{ file.text || "暂无名称" }}</p>
    <div class="function-group-div">
      <div class="prrviewBtn" v-if="!hiddenPreview && isShowPreview" @click="previewFile">
        预览
      </div>
      <div class="downloadBtn" v-if="!hiddenDownLoad && isShowDownLoad" @click="downloadFile">
        下载
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasBufferPage",
  ctrlCaption: "预览页面",
  mixins: [$mixins.control],
  design: {
    isMask: false,
  },
  props: {
    isShowDownLoad: {
      type: Boolean,
      default: true,
    },
    isShowPreview: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hiddenDownLoad: false,
      hiddenPreview: false,
    };
  },
  created() {
    this.file = this.$route.params && !dsf.isEmptyObject(this.$route.params) ? this.$route.params : this.$route.query;
    if(this.file && this.file.hiddenDownLoad){
      this.hiddenDownLoad = (this.file.hiddenDownLoad == 1 ? true : false);
    }
    if(this.file && this.file.hiddenPreview){
      this.hiddenPreview = (this.file.hiddenPreview == 1 ? true : false);
    }
    if (dsf.isEmptyObject(this.file)) {
      this.file = this.getRequest(window.location);
      if (this.getRequest(window.location).subcode == "zwb") {
        this.getFileID();
      }
    }
  },
  mounted() {
    let title = this.$route.query.titleName;
    document.title = title || "预览";
  },
  methods: {
    previewFile() {
      let previewUrl =
        "preview/file?url=" +
        dsf.config.setting_public_file_host +
        this.file.url;
      previewUrl = dsf.url.getWebPath(previewUrl);
      let src = encodeURIComponent(
        previewUrl
      );
      this.$router.push({
        path: "/preFileIframe?src=" + src,
      });
    },
    getRequest(url) {
      let theRequest = new Object();
      if (url.hash.indexOf("?") != -1) {
        let str = url.hash.substr(url.hash.indexOf("?") + 1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURIComponent(
            strs[i].split("=")[1]
          );
        }
      }
      return theRequest;
    },
    getFileID() {
      this.dsf.http
        .get("teas/xyxt/pzw/getSeatPdf", {
          classId: dsf.getCookie("class_id") || this.user.user.classId,
        })
        .done((res) => {
          if (res.success) {
            this.queryFileID = res.data;
          } else {
            this.dsf.layer.toast(res.message);
          }
        })
        .error((res) => {
          this.dsf.layer.toast(res.message);
        })
        .always();
    },
    downloadFile() {
      var idString = this.$route.query.id || "";
      var fileName = this.$route.query.filename || "";
      var url = dsf.url.getWebPath("file/download");
      url = url + "?files=" + idString + "&zipName=" + fileName;
      url = window.location.origin + url;
      var u = navigator.userAgent;
      var isAndroid =
        u.indexOf("Android DreamsSoft") > -1 ||
        u.indexOf("Android DreamSoft") > -1; //android终端
      var isiOS = u.indexOf("iOS DreamSoft") > -1; //ios终端
      if (isAndroid) {
        $iaction.downloadFile(
          { url: url, title: fileName },
          function (s) {
            dsf.layer.message("下载成功", true);
          },
          function (e) {
            dsf.layer.message("下载失败", false);
          }
        );
      } else if (isiOS) {
        $MFile.download(
          {
            remoteFileAddr: url,
            target: "/" + fileName,
          },
          function (resp) {
            dsf.layer.message("下载成功", true);
          },
          function (error) {
            dsf.layer.message("下载失败", false);
          }
        );
      } else {
        return new Promise((resolve, rejest) => {
          var url = dsf.url.getWebPath("file/download");
          $(
            '<form action="' +
              url +
              '" method="get">' + // action请求路径及推送方法
              '<input type="text" name="files" value="' +
              idString +
              '"/>' + // id^fileName
              '<input type="text" name="zipName" value="' +
              (fileName || "") +
              '"/>' + // 压缩包名称
              "</form>"
          )
            .appendTo("body")
            .submit()
            .remove();
          setTimeout(() => {
            resolve();
          }, 50);
        });
      }
    },
  },
});
</script>
